import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Services } from "../components/site/Services";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { Process } from "../components/site/Process";
import { Gallery } from "../components/site/Gallery";
import { BeforeAfter } from "../components/site/BeforeAfter";
import { Testimonials } from "../components/site/Testimonials";
import { EstimateForm } from "../components/site/EstimateForm";
import { Footer } from "../components/site/Footer";
import { StickyMobileCTA } from "../components/site/StickyMobileCTA";

export default function Home() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Process />
      <Gallery />
      <BeforeAfter />
      <Testimonials />
      <EstimateForm />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
